import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

import { ConsultationDataProvider } from '../../providers/consultation-data/consultation-data';

@Component({

   selector: 'page-popover-hide',
   templateUrl: 'popover-hide.html'
})

export class PopoverHidePage
{

   private itemIdx;
   private itemObjIdx;
   private callback;


   /** ----- Constructor ----- **/

   constructor( private consultationData: ConsultationDataProvider,
                private viewCtrl: ViewController,
                private params: NavParams )
   {

      this.itemIdx = this.params.get( 'itemIdx' );
      this.itemObjIdx = this.params.get( 'itemObjIdx' );
      this.callback = this.params.get( 'callback' );

   }


   /** ----- View LifeCycle ----- **/

   onBtnClicked()
   {

      this.callback( this.itemIdx, this.itemObjIdx ).then( () => {

         this.viewCtrl.dismiss();
      });

   }

}



// WEBPACK FOOTER //
// ./src/pages/popover-hide/popover-hide.ts